export default "__VITE_ASSET__t4wRtbnl__"